import moment from "moment";
import { saveAs } from "file-saver";

import ExcelJS from "exceljs";
import {
  xlsxCellSerial,
  createXlsxColumn,
  createXlsxCellStyle,
  createColumnWidth,
  createColumnHeight,
  createColumnMerge,
} from "./excel";

import { ModuleExpandIcon } from "../components/diagram/components";
import {
  FormInputtext,
  FormInputnumber,
  FormCalendar,
  FormDropdown,
  FormCheckbox,
} from "../components/formElement";
import { decimalAddZero, formatNumber } from "./common";
import { system_table } from "./system";
import { parseExcelDateToDate } from "./common";

import { Dropdown } from "primereact/dropdown";

// 產生列表欄位
export function createColumns({
  pageSize = system_table.size, // 每頁幾筆資料
  type = "", // 類型 (list: 列表、import: 匯入)
  saveType = "no", // 儲存類型 (no: 無、single: 單筆儲存、multi: 多筆儲存)
  saveFun = () => {}, // 儲存方法
  activeTemplate = [], // 生效的模組資料 (匯入匯出)
  defaultTemplate = {}, // 預設的模組欄位設定
  formSetting = {}, // 表單設定 (react-hook-form)
  frozenSetting = { frozen: false, align: "left", column: [] }, // 凍結設定
  optionData = {}, // 選單資料
  disabled = false, // 是否禁止編輯
} = {}) {
  let temp = [];
  activeTemplate.forEach((item, index) => {
    let columnSetting = defaultTemplate[item.apiKey] ?? {
        checked: true,
        isShow: true,
        uiType: "string",
        width: 150,
        listUI: false,
        importUI: true,
      }, // 預設的欄位設定
      isDisabled = columnSetting[`${type}Disabled`] || disabled,
      isUI = columnSetting[`${type}UI`];

    if (!item.checked || !columnSetting.isShow) return;

    let uiSetting = {
      field: item.apiKey,
      header: item.name,
      className: columnSetting.width
        ? `flex-grow-1 flex-basis-${columnSetting.width / 10} p-1 ${
            !isUI ? "flex align-items-center px-2" : ""
          }`
        : "",
      style: {
        width: columnSetting.width ?? "auto",
        minWidth:
          columnSetting.minWidth ??
          (columnSetting.width ? columnSetting.width - 20 : 100),
      },
    };

    // 凍結欄位設定
    if (
      frozenSetting.frozen &&
      frozenSetting.column.indexOf(item.apiKey) !== -1
    ) {
      uiSetting.frozen = frozenSetting.frozen;
      uiSetting.alignFrozen = frozenSetting.align;

      // 凍結分割陰影
      if (
        (frozenSetting.align === "left" &&
          frozenSetting.column.indexOf(item.apiKey) ===
            frozenSetting.column.length - 1) ||
        (frozenSetting.align === "right" &&
          frozenSetting.column.indexOf(item.apiKey) === 0)
      ) {
        uiSetting.style.boxShadow = `${
          frozenSetting.align === "left" ? "" : "-"
        }3px 1px 5px rgb(0 0 0 / 5%)`;
      }
    }
    let tempColumns = {};
    if (!isUI) {
      tempColumns = {
        ...uiSetting,
        body: (data) => (
          <>
            {columnSetting.uiType === "select" ? (
              <>
                {
                  optionData?.[`${columnSetting.options}_obj`]?.[
                    data[item.apiKey]
                  ]?.showLabel
                }
              </>
            ) : columnSetting.uiType === "date" &&
              columnSetting.dateFormatLabel ? (
              <>
                {data[item.apiKey]
                  ? moment(data[item.apiKey]).format(
                      columnSetting.dateFormatLabel
                    )
                  : null}
              </>
            ) : columnSetting.uiType === "number" ? (
              <>{data[item.apiKey]}</>
            ) : (
              <>
                {!data[item.apiKey]
                  ? ""
                  : typeof data[item.apiKey] !== "object"
                  ? data[item.apiKey]
                  : JSON.stringify(data[item.apiKey])}
              </>
            )}
          </>
        ),
      };
    } else if (columnSetting.uiType === "string") {
      tempColumns = {
        ...uiSetting,
        body: (data, { rowIndex }) => (
          <>
            <FormInputtext
              className="p-sm"
              setting={formSetting}
              data={{
                name: `data[${rowIndex % pageSize}].${item.apiKey}`,
                disabled: isDisabled || data.flag === "delete",
                saveFun: () =>
                  saveFun({
                    rowIndex: rowIndex % pageSize,
                    apiKey: item.apiKey,
                  }),
              }}
            />
          </>
        ),
      };
    } else if (columnSetting.uiType === "number") {
      tempColumns = {
        ...uiSetting,
        body: (data, { rowIndex }) => (
          <>
            <FormInputnumber
              className="p-sm"
              setting={formSetting}
              data={{
                name: `data[${rowIndex % pageSize}].${item.apiKey}`,
                disabled: isDisabled || data.flag === "delete",
                saveFun: () =>
                  saveFun({
                    rowIndex: rowIndex % pageSize,
                    apiKey: item.apiKey,
                  }),
              }}
            />
          </>
        ),
      };
    } else if (columnSetting.uiType === "date") {
      tempColumns = {
        ...uiSetting,
        body: (data, { rowIndex }) => (
          <>
            <FormCalendar
              className="p-sm"
              setting={formSetting}
              data={{
                name: `data[${rowIndex % pageSize}].${item.apiKey}`,
                dateFormat: columnSetting.dateFormatUI,
                disabled: isDisabled || data.flag === "delete",
                showTime: !!columnSetting.showTime,
                showSeconds: !!columnSetting.showSeconds,
                saveFun: () =>
                  saveFun({
                    rowIndex: rowIndex % pageSize,
                    apiKey: item.apiKey,
                  }),
              }}
            />
          </>
        ),
      };
    } else if (columnSetting.uiType === "select") {
      tempColumns = {
        ...uiSetting,
        body: (data, { rowIndex }) => (
          <>
            <FormDropdown
              className="p-sm w-full"
              panelClassName="p-sm"
              setting={formSetting}
              data={{
                name: `data[${rowIndex % pageSize}].${item.apiKey}`,
                options: optionData[columnSetting.options],
                optionLabel: "showLabel",
                optionValue: "showValue",
                disabled: isDisabled || data.flag === "delete",
                saveFun: () =>
                  saveFun({
                    rowIndex: rowIndex % pageSize,
                    apiKey: item.apiKey,
                  }),
                // showClear: false,
              }}
            />
          </>
        ),
      };
    } else if (columnSetting.uiType === "check") {
      tempColumns = {
        ...uiSetting,
        body: (data, { rowIndex }) => (
          <>
            <FormCheckbox
              className="m-0"
              setting={formSetting}
              data={{
                name: `data[${rowIndex % pageSize}].${item.apiKey}`,
                label: "",
                type: "checked",
                value: true,
                disabled: isDisabled || data.flag === "delete",
                saveFun: () =>
                  saveFun({
                    rowIndex: rowIndex % pageSize,
                    apiKey: item.apiKey,
                  }),
              }}
            />
          </>
        ),
      };
    } else if (columnSetting.uiType === "pallet") {
      tempColumns = {
        ...uiSetting,
        body: (data, { rowIndex }) => <>pallet</>,
      };
    }

    temp.push(tempColumns);
  });
  return temp;
}

// 產生列表驗證設定
export function createSchema({
  type = "", // 類型(list: 列表、import: 匯入)
  activeTemplate = [], // 生效的模組資料(匯入匯出)
  defaultTemplate = {}, // 預設的模組欄位設定
  yup = null, // 表單驗證設定(react-hook-form)
} = {}) {
  let temp = {};
  activeTemplate.forEach((item, index) => {
    let columnSetting = defaultTemplate[item.apiKey] ?? {
        checked: true,
        isShow: true,
        uiType: "string",
        [`${type}UI`]: false,
      }, // 預設的欄位設定
      isUI = columnSetting[`${type}UI`];

    if (!item.checked || !columnSetting.isShow) return;

    // 有使用表單 UI 元件 且 必填 才需產生驗證設定
    if (!isUI || !columnSetting.required) return;

    if (columnSetting.uiType === "string") {
      temp[item.apiKey] = yup.string().required("必填");
    } else if (columnSetting.uiType === "number") {
      let tempSchema = yup.number().required("必填").nullable();
      if (columnSetting.min >= 0)
        tempSchema = tempSchema.moreThan(
          columnSetting.min,
          `需大於${columnSetting.min}`
        );
      temp[item.apiKey] = tempSchema;
    } else if (columnSetting.uiType === "date") {
      temp[item.apiKey] = yup.string().required("必填").nullable();
    } else if (columnSetting.uiType === "select") {
      temp[item.apiKey] = yup.string().required("必填").nullable();
    } else if (columnSetting.uiType === "check") {
      temp[item.apiKey] = yup.string().required("必填");
    }
  });

  return temp;
}

// 設定儲存資料 & 型態
export function formatTemplateColumns({
  type = "import", // import: 匯入、export: 匯出
  template = {}, // 模組資料
  data = [], // 儲存的資料
} = {}) {
  let tempData = [],
    tempColumns = Object.values(template);

  data.forEach((item) => {
    let row = {};
    tempColumns.forEach((column) => {
      let val = item[column[type === "import" ? "value" : "apiKey"]];

      if (val !== "" && val !== undefined && val !== null) {
        if (
          column.uiType === "number" ||
          (column.uiType === "select" && column.optionType === "number")
        ) {
          val = Number(val);
        } else if (column.uiType === "date" && column.dateFormatLabel) {
          if (typeof val === "number") val = parseExcelDateToDate(val);
          val = moment(val).format(column.dateFormatLabel);
        } else if (column.uiType === "check") {
          val = Boolean(val);
        } else {
          val = String(val);
        }

        if (type === "import" || (type === "export" && column.listUI)) {
          row[column.apiKey] = val;
        }
      }
    });
    tempData.push(row);
  });

  return tempData;
}

// 頁碼設定
export const ModuleTablePaginator = {
  layout:
    "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
  RowsPerPageDropdown: (options) => {
    const dropdownOptions = [
      { label: 10, value: 10 },
      { label: 25, value: 25 },
      { label: 50, value: 50 },
      // { label: "All", value: options.totalRecords },
    ];

    return (
      <Dropdown
        value={options.value}
        options={dropdownOptions}
        onChange={options.onChange}
      />
    );
  },
};

/*
  整理展開標題欄位
  @params columns: 欄位
  @params expandChild: 展開子欄位
  @params tbExpandColumns: 目前展開欄位
  @params handleTbExpand(): 展開函式
*/
export function formatTbExpandColumns({
  rootColumns = [],
  expandColumns = [],
  tbExpandColumns = {},
  handleTbExpand,
} = {}) {
  let isExpand = Object.values(tbExpandColumns).some((item) => item);
  return rootColumns.map((rtColumn) => ({
    key: rtColumn.key,
    field: `${rtColumn.key}${rtColumn.isNumber ? "_format" : ""}`,
    header: () => (
      <div>
        <ModuleExpandIcon
          handleExpand={() => handleTbExpand({ key: rtColumn.prefixKey })}
        />
        <span>{rtColumn.headerName}</span>
      </div>
    ),
    headerRaw: rtColumn.headerName,
    className: rtColumn.className,
    colSpan: tbExpandColumns[rtColumn.prefixKey]
      ? rtColumn.colSpan ?? expandColumns.length
      : rtColumn.colSpan ?? 1,
    rowSpan:
      tbExpandColumns[rtColumn.prefixKey] || !isExpand
        ? rtColumn.rowSpan ?? 1
        : rtColumn.rowSpan ?? 2,
    isExpand: !!tbExpandColumns[rtColumn.prefixKey],
    child: expandColumns.map((epColumn) => ({
      key: `${rtColumn.prefixKey}_${epColumn.suffixKey}`,
      field: `${rtColumn.prefixKey}_${epColumn.suffixKey}${
        epColumn.isNumber ? "_format" : ""
      }`,
      header: epColumn.name,
      className: epColumn.className,
      colSpan: epColumn.colSpan ?? 1,
      rowSpan: epColumn.rowSpan ?? 1,
      child: epColumn.child?.map((ep2Column) => ({
        key: `${rtColumn.prefixKey}_${epColumn.suffixKey}${
          ep2Column.suffixKey ? `_${ep2Column.suffixKey}` : ""
        }`,
        field: `${rtColumn.prefixKey}_${epColumn.suffixKey}${
          ep2Column.suffixKey ? `_${ep2Column.suffixKey}` : ""
        }${ep2Column.isNumber ? "_format" : ""}`,
        header: ep2Column.name,
        className: ep2Column.className,
      })),
    })),
  }));
}

/*
  下載 Excel
  @params moduleTitle?: 標題
  @params progressAction(flag): loading 開關 Fun (flag: true/false)
*/
export const exportTbExcel = async (options) => {
  const { moduleTitle, progressAction } = options;
  progressAction(true);

  const defaulTitle = "匯出表格";

  const workbook = new ExcelJS.Workbook();
  createExcelSheet({ workbook, defaulTitle, ...options });
  const mainBuffer = await workbook.xlsx.writeBuffer();
  const mainFileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
  const mainBlob = new Blob([mainBuffer], { type: mainFileType });
  saveAs(mainBlob, (moduleTitle ?? defaulTitle) + ".xlsx");

  setTimeout(() => {
    progressAction(false);
  }, 1000);
};

/*
  建立 workbook sheet
  @params workbook: Excel 對象
  @params defaulTitle: 預設標題
  @params moduleTitle?: 標題
  @params headColumns: 表格 header 欄位
  @params footColumns: 表格 footer 欄位
  @params data: 表格主體資料
  @params tbCellClass: 欄位樣式
  @params nullTransfer: null資料轉換
*/
const createExcelSheet = ({
  workbook,
  defaulTitle,
  moduleTitle,
  headColumns,
  footColumns,
  data,
  tbCellClass,
  nullTransfer,
}) => {
  let ws = workbook.addWorksheet(moduleTitle ?? defaulTitle),
    columnsMerge = [],
    columnWidth = [],
    columnHeight = [],
    columnIdx = {
      col: -1,
      row: 0,
    },
    commonStyle = {
      align_h: "center",
      border_color: "d0cece",
    },
    colLength = headColumns[0].data.reduce(
      (pre, cur) => (pre += cur.colSpan ?? 1),
      0
    );

  // 表格大標題
  if (moduleTitle) {
    columnIdx.row++;
    createXlsxColumn({
      ws,
      column: `A${columnIdx.row}`,
      value: moduleTitle,
      styles: createXlsxCellStyle({
        ...commonStyle,
        font_color: "ffffff",
        font_bold: true,
        fill_color: "6ca9cf",
        align_h: "left",
      }),
    });
    columnsMerge.push({
      column: `A${columnIdx.row}:${xlsxCellSerial[colLength - 1]}${
        columnIdx.row
      }`,
    });
    columnHeight.push({ column: 1, height: 20 });
  }

  // 表格欄位 header
  let contentColumns = createExcelHeadFoot({
    ws,
    key: "header",
    columns: headColumns,
    columnIdx,
    columnsMerge,
    commonStyle,
  });

  // 表格內容
  data.forEach((rows) => {
    columnIdx.col = 0;
    columnIdx.row++;
    contentColumns.forEach((column) => {
      createXlsxColumn({
        ws,
        column: `${xlsxCellSerial[columnIdx.col]}${columnIdx.row}`,
        value: rows[column.key] === null ? nullTransfer : rows[column.key],
        styles: createXlsxCellStyle({
          ...commonStyle,
          fill_color:
            (tbCellClass?.subTitle || [])?.indexOf(column.key) !== -1
              ? "e9f3f9"
              : (tbCellClass?.thirdTitle || [])?.indexOf(column.key) !== -1
              ? "fff3e1"
              : "ffffff",
        }),
      });

      if (rows[`colSpan_${column.key}`] || rows[`rowSpan_${column.key}`]) {
        columnsMerge.push({
          column: `${xlsxCellSerial[columnIdx.col]}${columnIdx.row}:${
            xlsxCellSerial[
              columnIdx.col + (rows[`colSpan_${column.key}`] ?? 1) - 1
            ]
          }${columnIdx.row + (rows[`rowSpan_${column.key}`] ?? 1) - 1}`,
        });
      }

      columnIdx.col++;
    });
  });

  // 表格欄位 footer
  createExcelHeadFoot({
    ws,
    key: "footer",
    columns: footColumns,
    columnIdx,
    columnsMerge,
    commonStyle,
  });

  for (let i = 0; i < colLength; i++) {
    columnWidth.push({ column: xlsxCellSerial[i], width: 15 });
  }
  createColumnWidth({
    ws,
    columns: columnWidth,
  });

  createColumnHeight({
    ws,
    columns: columnHeight,
  });

  createColumnMerge({
    ws,
    columns: columnsMerge,
  });
};

/*
  建立 workbook sheet header 或 footer
  @params ws: Excel Sheet
  @params key: 類型 (header/footer)
  @params columns: 欄位
  @params columnIdx: 欄位位置(col: 行, row: 列)
  @params columnsMerge: 合併欄位
  @params commonStyle: 欄位共用樣式
*/
const createExcelHeadFoot = ({
  ws,
  key,
  columns,
  columnIdx,
  columnsMerge,
  commonStyle,
}) => {
  if (!columns) return;

  let contentColumns = [];

  columns.forEach((rows) => {
    columnIdx.col = 0;
    columnIdx.row++;
    rows.data.forEach((column) => {
      if (column[key] !== null) {
        createXlsxColumn({
          ws,
          column: `${xlsxCellSerial[columnIdx.col]}${columnIdx.row}`,
          value:
            typeof column[key] === "function"
              ? column[`${key}Raw`]
              : column[key],
          styles: createXlsxCellStyle({
            ...commonStyle,
            font_bold: true,
            fill_color: "e9f3f9",
          }),
        });
        if (column.colSpan || column.rowSpan) {
          columnsMerge.push({
            column: `${xlsxCellSerial[columnIdx.col]}${columnIdx.row}:${
              xlsxCellSerial[columnIdx.col + (column.colSpan ?? 1) - 1]
            }${columnIdx.row + (column.rowSpan ?? 1) - 1}`,
          });
        }
      }

      if (key === "header") {
        // 產生表格內容對應的欄位
        if (column.header !== null) contentColumns[columnIdx.col] = column;
      }

      columnIdx.col += column.colSpan ?? 1;
    });
  });

  return contentColumns;
};

/*
  整理數字欄位
  @params data: 轉換資料
  @params columns: 欄位
*/
export function formatTbNumberColumns({
  data = [],
  columns = [],
  nullTransfer = 0,
} = {}) {
  return data.map((item) => {
    let row = { ...item };
    columns.forEach((column) => {
      row[`${column}_format`] =
        row[column] === null
          ? nullTransfer
          : decimalAddZero({
              rawVal: formatNumber(row[column]),
              decimalShowRaw: true,
            });
    });
    return row;
  });
}

/*
  整理數字欄位
  @params data: 轉換資料
  @params columns: 欄位
*/
export function formatTbPercent({
  data = [],
  columns = [],
  nullTransfer = 0,
} = {}) {
  if (!data[0]) return data;

  let total = columns.reduce((pre, cur) => ({ ...pre, [cur]: 0 }), {});
  columns.forEach((column) => {
    data.forEach((item) => (total[column] += item[column]));
  });
  data.forEach((item) => {
    columns.forEach((column) => {
      let percent = Math.round((item[column] * 100) / total[column]);
      item[`${column}_percent`] = percent;
      item[`${column}_percent_format`] = `${percent}%`;
    });
  });
  return data;
}

/*
  計算總和
  @params data: 轉換資料
  @params columns: 欄位
*/
export function calculateTbColSum({ data = {}, columns = [] } = {}) {
  return columns.reduce(
    (pre, cur) => (pre += isNaN(data[cur]) ? 0 : data[cur]),
    0
  );
}

/*
  計算總和
  @params data: 轉換資料
  @params columns: 欄位
*/
export function calculateTbRowSum({ data = [], columns = [] } = {}) {
  let footData = { total_col: 0 };
  data.forEach((item) => {
    columns.forEach((column) => {
      let value = Number(item[column]);
      if (!footData[column]) footData[column] = 0;
      footData[column] += Number(item[column]);
      footData.total_col += isNaN(value) ? 0 : value;
    });
  });

  return {
    ...footData,
    ...Object.entries(footData).reduce(
      (pre, cur) => ({
        ...pre,
        [`${cur[0]}_format`]: isNaN(cur[1])
          ? "-"
          : decimalAddZero({
              rawVal: formatNumber(cur[1]),
              decimalShowRaw: true,
            }),
      }),
      {}
    ),
  };
}
